/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import Header from '../../components/header.js';
import Footer from '../../components/footer.js';
import Button from '../../components/buttons/primary.js';
import WhyCyperhost from '../../components/sections/whyCyperhost.js';
import DDoSProtection from '../../components/sections/ddosProtection';
import Reviews from '../../components/sections/reviews';
// Images
import Hero from '../../assets/images/web/hero.svg';
import Powerful from '../../assets/images/hosting/powerful.svg';
import Secure from '../../assets/images/hosting/secure.svg';
import Affordable from '../../assets/images/hosting/affordable.svg';
import SSD from '../../assets/images/hosting/ssd.svg';
import Panel from '../../assets/images/web/panel.svg';

const Web = () => {
    return (
        <main>
            <div className="home-hero mb-10">
                <Header />
                <div className="content max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5 pt-24">
                    <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 items-center'>
                        <div>
                            <h1 className="text-gray-200 text-5xl font-semibold mb-12">Website Hosting</h1>
                            <div className='flex flex-wrap items-center mb-9'>
                                <div className='flex items-center text-gray-100 font-semibold text-xl mr-7 w-full sm:w-full md:w-full lg:w-auto mb-3 sm:mb-3 md:mb-3 lg:mb-0'>
                                    <img src={Powerful} alt="Powerful" className='mr-3.5' /> Powerful
                                </div>
                                <div className='flex items-center text-gray-100 font-semibold text-xl mr-7 w-full sm:w-full md:w-full lg:w-auto mb-3 sm:mb-3 md:mb-3 lg:mb-0'>
                                    <img src={Secure} alt="Secure" className='mr-3.5' /> Secure
                                </div>
                                <div className='flex items-center text-gray-100 font-semibold text-xl w-full sm:w-full md:w-full lg:w-auto'>
                                    <img src={Affordable} alt="Affordable" className='mr-3.5' /> Affordable
                                </div>
                            </div>
                            <p className='text-gray-300'>Powerful and intuitive easy to use Web hosting. We don't overcomplicate things. It just works.</p>
                        </div>
                        <div className='hidden sm:hidden md:hidden lg:block'>
                            <img src={Hero} alt="Hero Image" className='block ml-auto' />
                        </div>
                    </div>
                </div>
            </div>
            <section className="plans max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-24">
                <div className="primary-gradient px-3 sm:px-3 md:px-6 lg:px-10 rounded-md pt-16 pb-24">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-16 px-4 place-content-evenly">
                        <div className='plan bg-box py-12 px-10 rounded-lg'>
                            <div className='header mb-11'>
                                <h1 className='text-gray-100 font-semibold text-3xl text-center'>Starter</h1>
                            </div>
                            <div className='body mb-10'>
                                <div className='domains flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Domains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>1</h2>
                                    </div>
                                </div>
                                <div className='domains flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Storage</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>15GB</h2>
                                    </div>
                                </div>
                                <div className='bandwidth flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Bandwidth</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>100GB</h2>
                                    </div>
                                </div>
                                <div className='ftp flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>FTP Accounts</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>1</h2>
                                    </div>
                                </div>
                                <div className='sql flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>SQL Database</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>1</h2>
                                    </div>
                                </div>
                                <div className='email flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Email Addresses</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>5</h2>
                                    </div>
                                </div>
                                <div className='subdomains flex items-center'>
                                    <div>
                                        <h1 className='text-gray-300'>Subdomains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>10</h2>
                                    </div>
                                </div>
                            </div>
                            <div className='footer'>
                                <div className='price mb-6'>
                                    <h1 className='text-gray-100 text-3xl font-semibold text-center'>$2.50 <span className='text-gray-300 text-sm font-normal'>/month</span></h1>
                                </div>
                                <div className='add-cart flex justify-center'>
                                    <Button title="Add to Cart" link="https://client.cyperhost.com/cart.php?a=add&pid=77" />
                                </div>
                            </div>
                        </div>
                        <div className='plan bg-box py-12 px-10 rounded-lg'>
                            <div className='header mb-11'>
                                <h1 className='text-gray-100 font-semibold text-3xl text-center'>Personal</h1>
                            </div>
                            <div className='body mb-10'>
                                <div className='domains flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Domains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>2</h2>
                                    </div>
                                </div>
                                <div className='domains flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Storage</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>30GB</h2>
                                    </div>
                                </div>
                                <div className='bandwidth flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Bandwidth</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unmetered</h2>
                                    </div>
                                </div>
                                <div className='ftp flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>FTP Accounts</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>2</h2>
                                    </div>
                                </div>
                                <div className='sql flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>SQL Database</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>3</h2>
                                    </div>
                                </div>
                                <div className='email flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Email Addresses</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='subdomains flex items-center'>
                                    <div>
                                        <h1 className='text-gray-300'>Subdomains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                            </div>
                            <div className='footer'>
                                <div className='price mb-6'>
                                    <h1 className='text-gray-100 text-3xl font-semibold text-center'>$4.50 <span className='text-gray-300 text-sm font-normal'>/month</span></h1>
                                </div>
                                <div className='add-cart flex justify-center'>
                                    <Button title="Add to Cart" link="https://client.cyperhost.com/cart.php?a=add&pid=78" />
                                </div>
                            </div>
                        </div>
                        <div className='plan bg-box py-12 px-10 rounded-lg'>
                            <div className='header mb-11'>
                                <h1 className='text-gray-100 font-semibold text-3xl text-center'>Enterprise</h1>
                            </div>
                            <div className='body mb-10'>
                                <div className='domains flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Domains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>10</h2>
                                    </div>
                                </div>
                                <div className='domains flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Storage</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>45GB</h2>
                                    </div>
                                </div>
                                <div className='bandwidth flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Bandwidth</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unmetered</h2>
                                    </div>
                                </div>
                                <div className='ftp flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>FTP Accounts</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>6</h2>
                                    </div>
                                </div>
                                <div className='sql flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>SQL Database</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>7</h2>
                                    </div>
                                </div>
                                <div className='email flex items-center mb-2'>
                                    <div>
                                        <h1 className='text-gray-300'>Email Addresses</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                                <div className='subdomains flex items-center'>
                                    <div>
                                        <h1 className='text-gray-300'>Subdomains</h1>
                                    </div>
                                    <div className='ml-auto'>
                                        <h2 className='text-gray-300 font-semibold'>Unlimited</h2>
                                    </div>
                                </div>
                            </div>
                            <div className='footer'>
                                <div className='price mb-6'>
                                    <h1 className='text-gray-100 text-3xl font-semibold text-center'>$9.00 <span className='text-gray-300 text-sm font-normal'>/month</span></h1>
                                </div>
                                <div className='add-cart flex justify-center'>
                                    <Button title="Add to Cart" link="https://client.cyperhost.com/cart.php?a=add&pid=79" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='hardware py-28 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5 pt-12 pb-24'>
                <div className="header mb-24">
                    <h1 className="text-gray-100 text-center text-3xl font-semibold mb-4">Top notch Hardware</h1>
                </div>
                <div className='body grid grid-cols-1 gap-y-16'>
                    <div className='ssd grid grid-cols-1 md:grid-cols-5 gap-5 items-center'>
                        <div className='col-span-1 md:col-span-2'>
                            <img src={SSD} alt="SSD" />
                        </div>
                        <div className='col-span-1 md:col-span-3'>
                            <h1 className='text-gray-100 text-2xl font-semibold mb-5'>Intel NVMe SSD drives</h1>
                            <p className='text-gray-300 text-lg'>Our cloud-focused Intel U.2 NVMe SSD drives offer the absolute fastest in server loading and response times.</p>
                        </div>
                    </div>
                    <div className='panel grid grid-cols-1 md:grid-cols-5 gap-5 items-center'>
                        <div className='col-span-1 md:col-span-3'>
                            <h1 className='text-gray-100 text-right text-2xl font-semibold mb-5'>Powerful Control Panel</h1>
                            <p className='text-gray-300 text-lg text-right'>Running the latest control panel for webhosting lets us be ahead of our competitors.</p>
                        </div>
                        <div className='col-span-1 md:col-span-2'>
                            <img src={Panel} alt="Panel" className='ml-auto' />
                        </div>
                    </div>
                </div>
            </section>
            <DDoSProtection />
            <WhyCyperhost />
            <Reviews />
            <Footer />
        </main>
    )
}

export default Web